export default "__VITE_ASSET__Uxce0Diy__"